import React from 'react';
import orange from '@mui/material/colors/orange';
import {useAuthMethod, useAuthUser} from '../../../../../utility/AuthHooks';
import {Box, alpha} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {Fonts} from '../../../../../../shared/constants/AppEnums';

const ROLE_LABELS = {
  superadmin: 'Super Admin',
  provider: 'Provider',
  user: 'User',
  portal_user: 'Portal User',
};

const UserInfo = () => {
  const {logout} = useAuthMethod();
  const {user} = useAuthUser();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const displayName = user?.name || user?.full_name || user?.email || 'User';
  const roleLabel = ROLE_LABELS[user?.role] || user?.role || 'Authorized';

  const getUserAvatar = () => displayName.charAt(0).toUpperCase();

  return (
    <Box
      sx={{
        py: 3,
        px: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Box onClick={handleClick}>
        <Avatar
          sx={{
            height: 30,
            width: 30,
            fontSize: 20,
            backgroundColor: orange[500],
          }}
        >
          {getUserAvatar()}
        </Avatar>
      </Box>

      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{py: 4}}
      >
        <MenuItem
          sx={{
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.08),
            px: 6,
            py: 3,
          }}
        >
          <Box sx={{mr: 3.5}}>
            <Avatar
              sx={{
                height: 30,
                width: 30,
                fontSize: 20,
                backgroundColor: orange[500],
              }}
            >
              {getUserAvatar()}
            </Avatar>
          </Box>
          <Box>
            <Box
              sx={{
                mb: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 14,
                fontWeight: Fonts.MEDIUM,
              }}
              component='span'
            >
              {displayName}
            </Box>
            <Box
              sx={{
                mt: -0.5,
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: 12,
                color: (theme) => theme.palette.text.secondary,
              }}
            >
              {roleLabel}
            </Box>
          </Box>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            logout();
          }}
          sx={{px: 6, py: 1.5}}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserInfo;
